@if ((currentDbUser?.userGroups?.length ?? 0) > 1) {
  <div
    *hasPermission="[EPermissions.userGroupReadOwn, EPermissions.userGroupSwitchOwn]; requireAll: true"
    class="group-select"
    role="button"
    aria-label="User group selector"
    tabindex="0"
  >
    <div class="relative">
      <div class="group-select__icon" (click)="store.loading$() ? null : userGroupSelect.open()">
        <app-icon src="/icons/buildings.svg" alt="User groups" class="w-5 h-5" [class.opacity-50]="store.loading$()" />
      </div>

      @if (store.loading$()) {
        <app-dots-spinner class="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 icon-spinner" />
      }
    </div>

    <mat-form-field class="group-select__field custom-form">
      <mat-select
        #userGroupSelect="matSelect"
        [value]="currentDbUser?.userGroupId"
        [hideSingleSelectionIndicator]="true"
        [disabled]="store.loading$()"
        (selectionChange)="onUserGroupChange($event.value)"
      >
        <mat-option>
          <ngx-mat-select-search
            noEntriesFoundLabel=""
            [formControl]="userGroupSearchControl"
            [placeholderLabel]="'shared.search' | translate"
          >
            <app-icon ngxMatSelectSearchClear src="icons/close.svg" alt="close" class="w-4 h-4" />
          </ngx-mat-select-search>
        </mat-option>

        @for (userGroup of filteredUserGroups(); track userGroup.id) {
          <mat-option [value]="userGroup.id">{{ userGroup.name }}</mat-option>
        }
      </mat-select>

      @if (store.loading$()) {
        <app-dots-spinner class="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2" />
      }
    </mat-form-field>
  </div>
}
